
<div class="container rich-text-editor-container">
	<div class="content">
		<div [formGroup]="edform">
			<div class="editor" >
				<ngx-editor-menu *ngIf="_showInEditorItem === '_editor' || _showInEditorItem === ''" [editor]="editor" [toolbar]="toolbar">
				</ngx-editor-menu>
				<ngx-editor [editor]="editor" formControlName="editorContent" >
				</ngx-editor>
			</div>
		</div>
</div>
</div>
